import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from "../../../store/actions";
import { i18n } from '../../../translate/i18n';
import {
  Typography, IconButton, FormControl, TextField,
} from '@mui/material';

import {
  Close,
} from '@mui/icons-material';

import {
  FormStyled, DoneIconStyled, DivSubmitButtons, DivFormTitle
} from '../Forms/styles';

import Spinner from '../../../components/Spinner/index';

const ModalParamEquipmentServicesGroup = (props) => {
  const dispatch = useDispatch();

  const [isNewData, setIsNewData] = useState(true);

  const [name, setName] = useState('');
  const [groupError, setNameError] = useState(false);

  const loading = false;

  const postQuestions = (body) => dispatch(actions.postQuestions(body))
  const updateQuestions = (questionId, body) => dispatch(actions.updateQuestions(questionId, body))

  const selectedSites = useSelector(state => state.sites.selectedSitesQuestions);

  //check if is newEntrance or editing
  useEffect(() => {
    if (props.modalContent) {
      setName(props.modalContent.name)
      setIsNewData(false)
    } else {
      setIsNewData(true)
    }
  }, [])

  const handleSubmit = async e => {
    e.preventDefault();
    let hasError = false;

    if (selectedSites.length === 0) {
      hasError = true;
    }

    if (!name) {
      setNameError(true)
      hasError = true;
    }

    if (hasError) return;

    const body = {
      type: 'group',
      name: name.toUpperCase(),
      equipmentService: props.equipmentServiceId,
      site: selectedSites[0]._id
    };

    if (isNewData) {
      postQuestions(body).then(result => {
        if (result !== 'error') {
          props.closeModal(result)
          dispatch(actions.updateEquipmentServiceInModel(result))
        }
      })
    } else {
      updateQuestions(props.modalContent._id, body).then(result => {
        if (result !== 'error') {
          props.closeModal(result)
          dispatch(actions.updateEquipmentServiceInModel(result))
        }
      })
    }
  }

  const styles = {
    opacityContainer: {
      opacity: loading ? '0.3' : '1',
      position: 'relative'
    },
  }

  return (
    <FormStyled onSubmit={handleSubmit} style={styles.opacityContainer}>

      {loading && <Spinner overlay />}

      <DivFormTitle>
        <Typography variant='h6'>{`${isNewData ? i18n.t('typographyModalEquipServiceGroup.true') : i18n.t('typographyModalEquipServiceGroup.false')} ${i18n.t('typographyModalEquipServiceGroup.text')} ${selectedSites.length > 0 && '(' + selectedSites[0].name + ')'}`}</Typography>
      </DivFormTitle>

      <>
        <FormControl variant="standard" fullWidth>
          <TextField
            variant="standard"
            multiline
            label={i18n.t('textFieldModalEquipServiceGroup.name')}
            name='group'
            onChange={event => { setNameError(false); return setName(event.target.value) }}
            value={name}
            margin='normal'
            error={groupError}
            autoFocus
            InputLabelProps={{
              shrink: true,
            }} />
        </FormControl>
      </>

      <DivSubmitButtons>
        <IconButton onClick={() => props.closeModal()} size="large"><Close fontSize='large' color='error' /></IconButton>
        <IconButton type="submit" size="large"><DoneIconStyled fontSize='large' /></IconButton>
      </DivSubmitButtons>

    </FormStyled>
  );
}

export default ModalParamEquipmentServicesGroup;
